<div class="w-full flex flex-col gap-4">
  <ngx-form-factory
    [form]="form"
    [formFields]="fieldsService.mainFields"
    (keydown.enter)="onLogin()"
  />

  <div
    class="w-fit mx-auto"
    id="otp-container"
    [ngClass]="{ 'h-24': showOtpForm(), 'h-0': !showOtpForm() }"
  >
    @if (showOtpForm()) {
      <lib-otp-code [control]="otpControl" (handleExpired)="onOtpExpired()" />
    }
  </div>
  <div class="flex flex-row items-center justify-between w-full gap-4">
    <a
      [routerLink]="['/auth/forgot-password']"
      class="hover:text-light-hover transition-all duration-200"
      >{{ 'auth.forgotPassword' | translate }}</a
    >
    <app-button
      [text]="'auth.login' | translate"
      (click)="onLogin()"
      [disabled]="showOtpForm() || form.invalid || isLoggingIn()"
      size="small"
    ></app-button>
  </div>
  @if (!!environment.DEV_ONLY_REMOVE_FOR_PROD?.IMPERSONATE_CREDENTIALS) {
    <app-button
      text="Impersonate"
      (click)="onImpersonate()"
      size="small"
    ></app-button>
  }
</div>
